import {FC} from 'react'
import useReactRouter from 'use-react-router'
import queryString from 'query-string'
import {useQuery} from 'hooks/graphql'
import {Presenter} from './Presenter'
import {EMPLOYEE, QueryVariables, QueryResult} from './query'

export const Detail: FC = () => {
  const {
    location: {search},
  } = useReactRouter()
  const {employee_id: employeeId} = queryString.parse(search)
  const {data, loading} = useQuery<QueryResult, QueryVariables>(EMPLOYEE, {variables: {id: String(employeeId)}})

  return !loading && data ? <Presenter employee={data.client.employee} /> : <></>
}
